// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

    --primary: #93C11F;
    --secondary: #6E8F16;
    --tertiary: #B8D94C;
    --accent-color: #B8D94C;
    --neutral-color: #A6A8AB;
    --highlight-color: #4EB3E5;
}


`, "",{"version":3,"sources":["webpack://./src/css/Root.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;AAC9B","sourcesContent":[":root {\n\n    --primary: #93C11F;\n    --secondary: #6E8F16;\n    --tertiary: #B8D94C;\n    --accent-color: #B8D94C;\n    --neutral-color: #A6A8AB;\n    --highlight-color: #4EB3E5;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
